<div class="info-window" ng-class="parameter.tipo">
  <header>
    <span class="header-title">{{parameter.title}}</span>
    <span class="header-detail text-white">
      <i class="fa fa-user fa-fw" aria-hidden="true"></i> {{nomeUsuario() | capitalize}} &nbsp;&nbsp;&nbsp;&nbsp;
      <i class="icon-updated" aria-hidden="true"></i> {{parameter.created_at | date: 'dd/MM/yy \'às\' HH:mm'}}
    </span>
  </header>

  <div class="iw-content width-100">
    <div class="iw-detail height-100 width-50" ng-include="parameter.template"></div>
    <div class="iw-img height-100 width-50">
      <uib-carousel active="0">
        <uib-slide class="rotate" ng-repeat="image in parameter.images track by image.id" index="image.id">
          <a ng-click="openImageLightBox(parameter.images, $index)" ng-show="!image.noImage">
            <div class="image-background-directive" agro-background-image="{{image.thumb}}" agro-background-image-height="270px"></div>
          </a>
          <img ng-src="{{image.thumb}}" style="margin:auto;" class="img-responsive" ng-show="image.noImage">
          <span ng-hide="image.noImage">
            <button class="btn-sm btn btn-white btn-info-window" ng-disabled="image.processing" title="Girar à esquerda" ng-click="rotate(image, 'left')">
              <span  ng-hide="image.processing">
                <i class="fa fa-undo" aria-hidden="true"></i>
              </span>
              <span ng-show="image.processing">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </button>
            <button class="btn-sm btn btn-white btn-info-window" ng-disabled="image.processing" title="Girar à direita" ng-click="rotate(image, 'right')">
              <span  ng-hide="image.processing">
                <i class="fa fa-repeat" aria-hidden="true"></i>
              </span>
              <span ng-show="image.processing">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </button>
          </span>
        </uib-slide>
      </uib-carousel>
    </div>
  </div>
  <footer class="text-muted">
    <small>
      Latitude: {{parameter.latitude}}.
      Longitude: {{parameter.longitude}}.
      <span ng-if="parameter.accuracy == 'MANUAL'">
        Ponto manual
        <button
          type="button"
          class="btn-link btn-xs"
          uib-tooltip="Personalizar latitude e longitude"
          ng-click="customLatLng()"
          ng-if="marker.dragging.enabled()"
        >
          <i class="fa fa-edit"></i>
        </button>
      </span>
      <span ng-if="parameter.accuracy != 'MANUAL'">Precisão: {{parameter.accuracy | number:1}}m</span>
    </small>

    <span ng-include src="'footer-' + parameter.template" />

  </footer>
</div>

<script type="text/ng-template" id="footer-info-stand.html">
  <span class="pull-right btn-acoes">
    <a ng-click="editStand()" ng-if="permissions.contagem.canManage">
      <i class="fa fa-pencil" tipped tipped-content="Editar contagem"></i>
    </a>
    <a ng-click="desativarRegistro($event, parameter, marker)" ng-if="parameter.registroAtivo">
      <i class="glyphicon glyphicon-trash" aria-hidden="true" tipped tipped-content="Desativar esta contagem"></i>
    </a>
    <a ng-click="generateTaskInfoWindow($event)" ng-if="permissions.tarefa.canManage">
      <i class="icon-newtask" aria-hidden="true" tipped tipped-content="Gerar tarefa"></i>
    </a>
  </span>
</script>

<script type="text/ng-template" id="footer-info-stand-cana.html">
  <span class="pull-right btn-acoes">
    <a ng-click="desativarRegistro($event, parameter, marker)" ng-if="parameter.registroAtivo">
      <i class="glyphicon glyphicon-trash" aria-hidden="true" tipped tipped-content="Desativar esta contagem"></i>
    </a>
    <a ng-click="generateTaskInfoWindow($event)" ng-if="permissions.tarefa.canManage">
      <i class="icon-newtask" aria-hidden="true" tipped tipped-content="Gerar tarefa"></i>
    </a>
  </span>
</script>

<script type="text/ng-template" id="footer-info-aspecto-geral.html">
  <span class="pull-right btn-acoes">
    <a ng-click="generateTaskInfoWindow($event)" ng-if="permissions.tarefa.canManage">
      <i class="icon-newtask" aria-hidden="true" tipped tipped-content="Gerar tarefa"></i>
    </a>
  </span>
</script>

<script type="text/ng-template" id="footer-semeadura_afericao.html">
  <span class="pull-right btn-acoes" ng-if="parameter.subtipo.id !== 'gema'">
    <a ng-click="generateTaskInfoWindow($event)" ng-if="permissions.tarefa.canManage">
      <i class="icon-newtask" aria-hidden="true" tipped tipped-content="Gerar tarefa"></i>
    </a>
  </span>
</script>

<script type="text/ng-template" id="footer-info-ocorrencia.html">
  <span class="pull-right btn-acoes">
    <a ng-click="editOcorrencia()" ng-if="parameter.selectedItems.length && permissions.ocorrencia.canManage">
      <i class="fa fa-pencil" tipped tipped-content="Editar ocorrência"></i>
    </a>
    <a ng-click="generateTaskFromOcorrencia($event)" ng-if="permissions.tarefa.canManage">
      <i class="icon-newtask" aria-hidden="true" tipped tipped-content="Gerar tarefa"></i>
    </a>
  </span>
</script>

<script type="text/ng-template" id="footer-info-produtividade.html">
  <span class="pull-right btn-acoes">
    <a ng-click="desativarRegistro($event, parameter, marker)" ng-if="parameter.registroAtivo">
      <i class="glyphicon glyphicon-trash" aria-hidden="true" tipped tipped-content="Desativar esta estimativa de produtividade"></i>
    </a>
  </span>
</script>

<script type="text/ng-template" id="footer-aplicacao_afericao.html">
  <span class="pull-right btn-acoes" ng-if="permissions.tarefa.canManage">
    <a ng-click="generateTaskFromOcorrencia">
      <i class="icon-newtask" aria-hidden="true" tipped tipped-content="Gerar tarefa"></i>
    </a>
</script>

<!-- footers não implementados -->
<script type="text/ng-template" id="footer-colheita_afericao.html"></script>
<script type="text/ng-template" id="footer-ponto_comentario.html"></script>
<!-- footers não implementados -->

<script type="text/ng-template" id="info-stand.html">
  <ng-include src="'cultura_cultivar_edit'"></ng-include>
  <p class="iw-subtitle clearfix">
    <i class="fa fa-calendar i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Plantio</span>
      <plantio class="second-line" safra="parameter.params.safra_id" gleba="parameter.params.gleba_id" insumo="parameter.params.cd_insumo"/>
    </span>
  </p>
  <p class="iw-subtitle clearfix">
    <i class="icon-stage i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">{{parameter.estadio.descricao | capitalize}}</span>
      <span class="second-line">({{parameter.estadio.abreviatura}})</span>
    </span>
  </p>
  <p>
    <div class="row no-margin">
      <div class="col-md-4 no-padding text-right iw-focus">plantas/ha:</div>
      <div class="col-md-8 no-padding">
        &nbsp;<span class="label-iw bg-{{parameter.classificacao}}" ng-class="{'text-white': !!parameter.classificacao}">&nbsp;{{parameter.density | number}} ({{parameter.variation | number:2}}%) </span>
        &nbsp;<i class="icon-info text-muted" aria-hidden="true" uib-tooltip-template="'tooltip-lines-stand.html'" tooltip-class="tooltip-lines-width" tooltip-placement="right" tooltip-append-to-body="true"></i>
      </div>
      <div class="clearfix"></div>
      <div class="col-md-4 no-padding text-right iw-focus">ideal/ha:</div>
      <div class="col-md-8 no-padding">&nbsp;&nbsp;{{parameter.ideal | number}}</div>
      <div class="col-md-4 no-padding text-right iw-focus">plantas/m²:</div>
      <div class="col-md-8 no-padding">&nbsp;&nbsp;{{parameter.plantasPorMetrosQuadrados | number}}</div>
    </div>
  </p>
  <p class="iw-subtitle clearfix">
    <i class="icon-info i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Informações da contagem</span>
    </span>
  </p>
  <ul class="list-unstyled text-muted">
    <li ng-if="parameter.hasAbsent">
      Plantas Ausentes: {{parameter.absentDensity | number:2}} - {{parameter.absentPercentage | number:2}}%
    </li>
    <li ng-if="parameter.uniformidade">
      Nível de Uniformidade: {{parameter.uniformidade}}
    </li>
    <li ng-if="parameter.hasDominant">
      Plantas Dominadas: {{parameter.dominantPercentage | number:2}}%
    </li>
    <li ng-if="parameter.hasCountNotUniform">
      Plantas Duplas: {{parameter.notUniformPercentage | number:2}}%
    </li>
    <li ng-if="parameter.observacoes.length > 0">
      {{parameter.observacoes}}
    </li>
    <li>Variação entre linha: {{parameter.coeficiente | number:2}}%</li>
    <span ng-if="parameter.configuration.informar_distancia">
      <li>Plantas Inconformes Pos. Ideal: {{parameter.plantasInconformes | number:2}}%</li>
      <li ng-class="uniformidadeDistribuicaoColor(parameter.uniformidadeDistribuicao)">
        Uniformidade da Distribuição (CV): {{parameter.uniformidadeDistribuicao | number:2}}%
        <i class="text-muted icon-info pointer" uib-popover-template="'popover-chart-distribuicao.html'" popover-append-to-body="true" popover-placement="right" popover-trigger="outsideClick"></i>
      </li>
    </span>
    <li>
      <span class="text-success pointer" uib-tooltip-template="'tooltip-infos-stand.html'"  tooltip-placement="right" tooltip-append-to-body="true">
        Mais Informações
      </span>
    </li>
  </ul>
</script>

<script type="text/ng-template" id="tooltip-lines-stand.html">
  <span ng-if="parameter.isCorn">
    <table class="table no-margin no-padding">
      <thead>
        <tr>
          <th>Plantas</th>
          <th>Ausentes</th>
          <th>Duplas</th>
          <th>Dominadas</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="line in parameter.lines track by $index">
          <td>{{line.plants}}</td>
          <td>{{line.absent }}</td>
          <td>{{line.notUniform }}</td>
          <td>{{line.dominant}}</td>
        </tr>
      </tbody>
    </table>
  </span>

  <span ng-if="parameter.isWheat">
    <table class="table no-margin no-padding">
      <thead>
        <tr>
          <th>Plantas</th>
          <th>Perfilhos</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="line in parameter.lines track by $index">
          <td>{{line.plants}}</td>
          <td>{{line.tillering}}</td>
        </tr>
      </tbody>
    </table>
  </span>
  <span ng-if="parameter.isCana">
    <table class="table no-margin no-padding">
      <thead>
        <tr>
          <th>Nº Falhas</th>
          <th>Dist. Entre Falhas</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="line in parameter.lines track by $index">
          <td>{{line.flaws}}</td>
          <td>{{line.flaw_distance}}</td>
        </tr>
      </tbody>
    </table>
  </span>

  <span ng-if="!parameter.isCorn && !parameter.isWheat && !parameter.isCana">
    <ul ng-repeat="line in parameter.lines track by $index" class="list-unstyled no-margin no-padding">
      <li class="no-margin no-padding text-left">Linha {{$index+1}}: <strong>{{line.plants}}</strong> plantas</li>
    </ul>
  </span>

</script>


<script type="text/ng-template" id="info-stand-cana.html">
  <ng-include src="'cultura_cultivar_edit'"></ng-include>
  <p class="iw-subtitle clearfix">
    <i class="fa fa-calendar i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Plantio</span>
      <plantio class="second-line" safra="parameter.params.safra_id" gleba="parameter.params.gleba_id" insumo="parameter.params.cd_insumo"/>
    </span>
  </p>
  <p class="iw-subtitle clearfix">
    <i class="icon-stage i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">{{parameter.estadio.descricao | capitalize}}</span>
      <span class="second-line">({{parameter.estadio.abreviatura}})</span>
    </span>
  </p>
  <p>
    <div class="row no-margin">
      <div class="col-md-8 no-padding text-right iw-focus">Área média de cana por ha:</div>
      <div class="col-md-4 no-padding">
        &nbsp;<span class="label-iw bg-{{parameter.classificacao}}">&nbsp;{{parameter.avg_area | number}} </span>
        &nbsp;<i class="icon-info text-muted" aria-hidden="true" uib-tooltip-template="'tooltip-lines-stand.html'" tooltip-class="tooltip-lines-width" tooltip-placement="right" tooltip-append-to-body="true"></i>
      </div>
      <div class="clearfix"></div>
      <div class="col-md-8 no-padding text-right iw-focus">Área total de cana :</div>
      <div class="col-md-4 no-padding">&nbsp;&nbsp;{{parameter.area_total | number}}</div>
      <div class="col-md-8 no-padding text-right iw-focus">Área amostrada por ponto :</div>
      <div class="col-md-4 no-padding">&nbsp;&nbsp;{{parameter.area_amostra_line | number}}</div>
    </div>
  </p>
  <p class="iw-subtitle clearfix">
    <i class="icon-info i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Informações da contagem</span>
    </span>
  </p>
  <ul class="list-unstyled text-muted">
    <li>
      Média de falhas: {{parameter.avg_flaws | number:1}} %
    </li>
    <li>
      <span class="text-success pointer" uib-tooltip-template="'tooltip-infos-stand.html'"  tooltip-placement="right" tooltip-append-to-body="true">
        Mais Informações
      </span>
    </li>
  </ul>
</script>

<script type="text/ng-template" id="popover-chart-distribuicao.html">
  <div>
    <div google-chart chart="uniformidadeDistribuicaoChart(parameter.lines)"></div>
    <h3>Posições</h3>
    <div class="table-responsive container-distancias">
      <table class="table table-hover">
        <tbody>
          <tr>
            <th>Pl. Inconf. Pos. Ideal</th>
            <th ng-repeat="n in [0,(parameter.lines | max:'plants')] | range" class="text-center">
              Planta {{$index + 1}}
            </th>
          </tr>
        </tbody>
        <tr ng-repeat="line in parameter.lines">
          <td>{{line.plantasInconformes | number:2}} %</td>
          <td ng-repeat="distancia in line.distancias">
            {{distancia.posicao | number:1}} cm
          </td>
        </tr>
      </table>
    </div>
  </div>
</script>

<script type="text/ng-template" id="info-produtividade.html">
  <ng-include src="'cultura_cultivar_edit'"></ng-include>
  <p class="iw-subtitle clearfix">
    <i class="fa fa-calendar i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Plantio</span>
      <plantio class="second-line" safra="parameter.params.safra_id" gleba="parameter.params.gleba_id" insumo="parameter.params.cd_insumo"/>
    </span>
  </p>
  <p class="iw-subtitle clearfix">
    <i class="icon-stage i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">{{parameter.estadio.descricao | capitalize}}</span>
      <span class="second-line">({{parameter.estadio.abreviatura}})</span>
    </span>
  </p>
  <p>
    <div class="row no-margin">
      <div ng-if="!parameter.isAlgodao && !parameter.isCana" class="col-md-4 no-padding text-right iw-focus">sc/ha:</div>
      <div ng-if="parameter.isAlgodao" class="col-md-4 no-padding text-right iw-focus">@/ha:</div>
      <div ng-if="parameter.isCana" class="col-md-4 no-padding text-right iw-focus">ton/ha:</div>
      <div class="col-md-8 no-padding">
        &nbsp;<span class="label-iw bg-{{parameter.classificacao}}" ng-class="{'text-white': !!parameter.classificacao}">&nbsp;{{parameter.fertility | number:2}} ({{parameter.variation | number:2}}%) </span>
        &nbsp;<i class="icon-info text-muted pointer" ng-click="modalInfo(parameter.templateItem)" aria-hidden="true"></i>
      </div>
      <div class="clearfix"></div>
      <div class="col-md-4 no-padding text-right iw-focus">meta/ha:</div>
      <div class="col-md-8 no-padding">&nbsp;&nbsp;{{parameter.ideal | number:2}}</div>
    </div>
  </p>
  <p class="iw-subtitle clearfix">
    <i class="icon-info i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Informações da produtividade</span>
    </span>
  </p>
  <div ng-if="parameter.isWheat" class="padding-left">
    <span>Médias</span>
    <ul class="text-muted">
      <li>Espigas/m<sup>2</sup>:  {{parameter.medias.spikesSquareMeters | number:2}}</li>
      <li>Espiguetas/Espiga:  {{parameter.medias.averageSpikelets | number:2}}</li>
      <li>Grãos/Espiga:  {{parameter.medias.averageGrains | number:2}}</li>
    </ul>
  </div>
  <ul class="list-unstyled text-muted padding-left">
    <li ng-if="!parameter.isAlgodao && !parameter.isCana">
      PMS: {{parameter.pms || 0 | number:2}} g
    </li>
    <li ng-if="parameter.isAlgodao">
      Peso do Capulho: {{parameter.pesoCapulho || 0 | number:2}} g
    </li>
    <li ng-if="parameter.isWheat">
      Índice de Perfilhamento: {{parameter.tillering || 0 | number:2}} %
    </li>
    <li>
      Fator de Correção: {{parameter.correcao || 0 | number:2 }} %
    </li>
    <li ng-if="(!parameter.isWheat && !parameter.isCorn && !parameter.isAlgodao && !parameter.isCana)">
      Tipo de Amostragem: {{parameter.configuration.type.name}}
    </li>
    <li ng-if="parameter.isWheat">
      Densidade Estabelecida: {{parameter.density | number:0}} pl/ha
    </li>
    <li ng-if="!parameter.isAlgodao && !parameter.isCana">
      <ul class="list-unstyled" ng-if="!parameter.isWheat">
      Densidade
        <li class="padding-left">Estabelecida: {{parameter.density | number:0}} pl/ha</li>
        <li class="padding-left">Produtivas: {{parameter.productiveDensity | number:0}} pl/ha ({{parameter.productiveDensityPercent || 0 | number:2}}%)</li>
      </ul>
    </li>
    <li ng-if="(!parameter.isWheat && !parameter.isCorn && !parameter.isAlgodao && !parameter.isCana)">
      Média de Grãos por Planta: {{parameter.grains | number:2}}
    </li>
    <li ng-if="parameter.area > 0">
      Área da Amostra: {{parameter.area || 0 | number:2}} metros<sup>2</sup>
    </li>
    <li>
      <span class="text-success pointer" uib-tooltip-template="'tooltip-infos-produtividade.html'" tooltip-placement="right" tooltip-append-to-body="true">
        Mais Informações
      </span>
    </li>
  </ul>
</script>

<script type="text/ng-template" id="tooltip-infos-produtividade.html">
  <div class="text-left">
    <ul class="list-unstyled">
      <li ng-if="parameter.area">
        Área da Amostra: {{parameter.area | number:2}} m<sup>2</sup>
      </li>
      <li>
        Quantidade de {{parameter.nameSamples}}: {{parameter.samples.length || 0 | number}}
      </li>
      <li ng-if="parameter.configuration.lines.lines_length > 0">
        Comprimento das linhas: {{parameter.configuration.lines.lines_length | number:2}} m
      </li>
      <li ng-if="parameter.configuration.lines.lines_distance > 0">
        Distância entre linhas: {{parameter.configuration.lines.lines_distance | number:2}} m
      </li>
      <li Ng-if="parameter.observacoes.length > 0">
        Obs: {{parameter.observacoes}}
      </li>
    </ul>
  </div>
</script>

<script type="text/ng-template" id="tooltip-infos-stand.html">
  <div class="text-left">
    Comprimento: {{parameter.configuration.lines_length | number:2}} m <br/>
    Distância entre linhas: {{parameter.configuration.lines_distance | number:2}} m <br/>
    Linhas contadas: {{parameter.number_of_lines}} {{parameter.number_of_lines > 1 ? ' linhas' : ' linha'}} <br/>
  </div>
</script>

<script type="text/ng-template" id="info-produtividade-item.html">
  <table class="table no-margin no-padding table-produtividade">
    <thead>
      <tr>
        <th class="text-right">Nós Improdutivos</th>
        <th class="text-right">Nós Produtivos</th>
        <th class="text-right" ng-hide="parameter.configuration.onlyGrains">Vagens por nós</th>
        <th class="text-right" ng-show="parameter.configuration.onlyGrains">Vagens</th>
        <th class="text-right" ng-hide="parameter.configuration.onlyGrains">Grãos por vagem</th>
        <th class="text-right" ng-show="parameter.configuration.onlyGrains">Grãos</th>
        <th class="text-right">Média de grãos por vagem</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="sample in parameter.samples track by $index">
        <td class="text-right">{{sample.unproductive_nodes | number}}</td>
        <td class="text-right">{{sample.nodes | number}}</td>
        <td class="text-right">{{sample.pods | number}}</td>
        <td class="text-right">{{sample.grains | number}}</td>
        <td class="text-right">{{sample.grains / sample.pods | number:2}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="text-right">
          <strong>{{parameter.samples | average:'unproductive_nodes' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{parameter.samples | average:'nodes' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{parameter.samples | average:'pods' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{parameter.samples | average:'grains' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{(parameter.samples | average:'grains') / (parameter.samples | average:'pods') | number:2}} </strong>
        </td>
      </tr>
    </tfoot>
  </table>
</script>

<script type="text/ng-template" id="info-produtividade-algodao-item.html">
  <table class="table no-margin no-padding table-produtividade">
    <thead>
      <tr>
        <th class="text-right">Capulhos</th>
        <th class="text-right">Peso total (gramas)</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="sample in parameter.samples track by $index">
        <td class="text-right">{{sample.capulhos | number}}</td>
        <td class="text-right">{{sample.peso | number}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="text-right">
          <strong>{{parameter.samples | average:'capulhos' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{parameter.samples | average:'peso' | number:1}}</strong>
        </td>
      </tr>
    </tfoot>
  </table>
</script>

<script type="text/ng-template" id="info-produtividade-cana-item.html">
  <table class="table no-margin no-padding table-produtividade">
    <thead>
      <tr>
        <th class="text-left">Peso (kg)</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="sample in parameter.samples track by $index">
        <td class="text-left">{{sample.weight | number}}</td>
      </tr>
    </tbody>
  </table>
</script>

<script type="text/ng-template" id="info-produtividade-trigo-item.html">

  <h5 class="text-center">{{parameter.nameSamples}}</h5>
  <table class="table no-margin no-padding table-produtividade">
    <thead>
      <tr>
        <th class="text-right">Espigas</th>
        <th class="text-right">Espiguetas</th>
        <th class="text-right">Grãos por espiguetas</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="sample in parameter.samples track by $index">
        <td class="text-right">{{sample.spike | number}}</td>
        <td class="text-right">{{sample.spikelet | number}}</td>
        <td class="text-right">{{sample.grains | number}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="text-right">
          <strong>{{parameter.samples | average:'spike' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{parameter.samples | average:'spikelet' | number:1}}</strong>
        </td>
        <td class="text-right">
          <strong>{{parameter.samples | average:'grains' | number:1}}</strong>
        </td>
      </tr>
    </tfoot>
  </table>
</script>

<script type="text/ng-template" id="info-produtividade-milho-item.html">
  <table class="table no-margin no-padding table-produtividade">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th ng-repeat="classificacao in parameter.cornClassifications | orderBy: 'weight'" class="text-center">
          {{classificacao.description}}
          <br>
          {{classificacao.weight}}g
          <div ng-show="classificacao.grains">{{classificacao.grains}} grãos</div>
          <div ng-show="classificacao.queues">{{classificacao.queues}} fileiras</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="sample in parameter.samples track by $index">
        <td>Linha {{$index+1}}</td>
        <td ng-repeat="classificacao in parameter.cornClassifications" class="text-center">
          {{sample[classificacao.description].corns || 0 | number}}
        </td>
      </tr>
    </tbody>
    <tfoot>
        <tr>
          <td>&nbsp;</td>
          <td ng-repeat="classificacao in parameter.cornClassifications" class="text-center">
            {{ parameter.cornMeans[classificacao.description] }}
          </td>
        </tr>
      </tfoot>
    </table>
</script>

<script type="text/ng-template" id="info-ocorrencia.html">
  <ng-include src="'cultura_cultivar_edit'"></ng-include>
  <p class="iw-subtitle clearfix">
    <i class="fa fa-calendar i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Plantio</span>
      <plantio class="second-line" safra="parameter.params.safra_id" gleba="parameter.params.gleba_id" insumo="parameter.params.cd_insumo"/>
    </span>
  </p>
  <p class="iw-subtitle" ng-if="parameter.estadio">
    <i class="icon-stage i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">{{parameter.estadio.descricao | capitalize}}</span>
      <span class="second-line">({{parameter.estadio.abreviatura}})</span>
    </span>
  </p>
  <p ng-include="parameter.tipoDeOcorrencia"></p>
  <p class="iw-info text-muted" ng-if="parameter.observacao.length > 0">
    {{parameter.observacao}}
  </p>
</script>

<script type="text/ng-template" id="boolean">
  <li>{{indicador.titulo | capitalize}}: {{(indicador.valor1 ? 'Sim' : 'Não')}}</li>
</script>

<script type="text/ng-template" id="percentual">
  <li>{{indicador.titulo | capitalize}}</li>
  <li>{{indicador.descricao1 | capitalize}}: {{indicador.valor1}}</li>
  <li>{{indicador.descricao2 | capitalize}}:
    <span class="label-iw bg-{{indicador.situacao.descricaoJson}} text-white">&nbsp;{{indicador.valor2}} ({{indicador.percentual || 0 | number:2}}%) </span>
  </li>
</script>

<script type="text/ng-template" id="contagem_plantas">
  <li>Contagem</li>
  <li>Entre nós: {{indicador.valor1}}</li>
  <li>Entre nós atacados:
    <span class="label-iw bg-{{indicador.situacao.descricaoJson}} text-white">&nbsp;{{indicador.valor2}} ({{indicador.percentual || 0 | number:2}}%) </span>
  </li>
</script>

<script type="text/ng-template" id="texto">
  <li>{{indicador.titulo | capitalize}}: <span class="label-iw bg-{{indicador.situacao.descricaoJson}} text-white">&nbsp;{{indicador.situacao.label}}&nbsp;</span></li>
</script>

<script type="text/ng-template" id="valor">
  <li>{{indicador.titulo | capitalize}}: <span class="label-iw bg-{{indicador.situacao.descricaoJson}}" ng-class="{'text-white': !!indicador.situacao}">&nbsp;{{indicador.valor1}}&nbsp;</span></li>
</script>

<script type="text/ng-template" id="praga">
  <div class="pointer iw-subtitle clearfix" ng-repeat="item in parameter.selectedItems">
    <i class="i-subtitle" agro-icon-historico historico="parameter" aria-hidden="true"></i>
    <span tooltip-append-to-body="true" uib-tooltip="{{item.nome_cientifico}}">{{item.descricao | capitalize}}</span>
    <a ng-if="item.temOcorrencias && permissions.ocorrencia.canManage" prevent-event href="#" ng-click="changeToNaoOcorrencia(item, parameter)" title="Marcar como não ocorrência">
      <i class="pointer text-danger fa fa-times"></i>
     </a>
    <ul class="list-unstyled iw-info iw-praga no-margin">
      <ng-include src="indicador.tipo" ng-repeat="indicador in item.indicadores track by $index" ng-if="indicador.valor1" />
    </ul>

    <ul ng-if="!item.temOcorrencias" class="list-unstyled iw-info iw-praga no-margin">
      <li><strong>Registro de NÃO ocorrência</strong></li>
    </ul>
  </div>
</script>

<script type="text/ng-template" id="climatica">
  <p class="iw-info">Evento: {{parameter.evento.descricao}}</p>
  <p class="iw-info">Situação: {{parameter.situacao}}</p>
  <p class="iw-info">Data Inicial: {{parameter.dataInicial | date:'shortDate'}}</p>
  <p class="iw-info">Data Final: {{parameter.dataFinal | date:'shortDate'}}</p>
</script>

<script type="text/ng-template" id="manutencao_melhoria">
  <p class="iw-info">Ação: {{parameter.acao}}</p>
  <p class="iw-info" ng-if="parameter.temTarefa">Gerada tarefa para {{parameter.responsavel.nome}}</p>
  <p class="iw-info" ng-if="parameter.temTarefa">Prazo máximo para execução {{ parameter.dataFinal | date: 'dd/MM/yyyy' }}</p>
</script>

<script type="text/ng-template" id="solo">
  <p class="iw-info">Situação: {{parameter.situacao}}</p>
  <p class="iw-info">Ação: {{parameter.acao}}</p>
</script>

<script type="text/ng-template" id="massa_seca_pastagem">
  <p class="iw-info">Altura: {{parameter.altura | number:1}} cm</p>
  <p class="iw-info">Massa seca de pastagem: {{parameter.quantidade_massa_seca | number:1}} kg/ha</p>
</script>

<script type="text/ng-template" id="info-aspecto-geral.html">
  <ng-include src="'cultura_cultivar_edit'"></ng-include>
  <p class="iw-subtitle clearfix">
    <i class="fa fa-calendar i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">Plantio</span>
      <plantio class="second-line" safra="parameter.params.safra_id" gleba="parameter.params.gleba_id" insumo="parameter.params.cd_insumo"/>
    </span>
  </p>
  <p class="iw-subtitle" ng-if="parameter.estadio">
    <i class="icon-stage i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">{{parameter.estadio.descricao | capitalize}}</span>
      <span class="second-line">({{parameter.estadio.abreviatura}})</span>
    </span>
  </p>
  <p class="iw-info text-muted" ng-if="parameter.observacoes.length > 0">
    {{parameter.observacoes}}
  </p>
  <audio class="iw-audio" controls ng-if="parameter.audio">
    <source src="{{parameter.audio.ogg_url}}" type="audio/ogg">
    <source src="{{parameter.audio.url}}" type="audio/mpeg">
    Seu navegador não suporta a reprodução de áudio
  </audio>
</script>

<script type="text/ng-template" id="colheita_afericao.html">
  <p class="iw-subtitle clearfix">
    <i class="icon-culture i-subtitle" aria-hidden="true"></i>
    <span>
      <span ng-if="parameter.atividade" class="first-line">{{parameter.atividade.descricao | capitalize}}</span>
      <span ng-if="parameter.insumo" class="second-line text-italic">({{parameter.insumo.descricao}})</span>
    </span>
  </p>

  <h3>
    {{parameter.maquina.descricao}}
  </h3>

  <h2>
    Perda Estimada: {{parameter.perda_kg | number:1}} kg/ha
  </h2>

  <h3 ng-if="parameter.percentual_perda"> <b>% Perda:</b> {{parameter.percentual_perda | number:2}}</h3>

  <ul class="list-unstyled">
    <li>
      <b>Área da Amostra:</b> {{parameter.area | number:1}}m<sup>2</sup>
    </li>
    <li>
      <b>Largura:</b> {{parameter.largura | number:1}}m
    </li>
    <li>
      <b>Comprimento:</b> {{parameter.comprimento | number:1}}m
    </li>
    <span ng-if="parameter.cana">
      <li>
        <b>Toco:</b> {{parameter.cana.toco | number:1}}g
      </li>
      <li>
        <b>Tolete:</b> {{parameter.cana.tolete | number:1}}g
      </li>
      <li>
        <b>Estilhaço:</b> {{parameter.cana.estilhaco | number:1}}g
      </li>
      <li>
        <b>Pedaço:</b> {{parameter.cana.pedaco | number:1}}g
      </li>
      <li>
        <b>Ponteiro:</b> {{parameter.cana.ponteiro | number:1}}g
      </li>
      <li>
        <b>Cana Fixa:</b> {{parameter.cana.cana_fixa | number:1}}g
      </li>
    </span>
    <li ng-if="parameter.pms">
      <b>PMS da Amostra:</b> {{parameter.pms | number:1}}g
    </li>
    <li ng-if="parameter.numero_graos">
      <b>Número de Grãos da Amostra:</b> {{parameter.numero_graos}}
    </li>
    <li>
      <b>Peso da Amostra:</b> {{parameter.peso | number:1}}g
    </li>
    <li>
      <b>Velocidade:</b> {{parameter.velocidade ? parameter.velocidade + 'km/h' : 'N/A'}}
    </li>
    <li ng-if="parameter.observacoes.length > 0">
      {{parameter.observacoes}}
    </li>
  </ul>
</script>

<script type="text/ng-template" id="semeadura_afericao.html">
  <p class="iw-subtitle clearfix">
    <i class="icon-culture i-subtitle" aria-hidden="true"></i>
    <span>
      <span ng-if="parameter.cultura" class="first-line">{{parameter.cultura.descricao | capitalize}}</span>
    </span>
  </p>

  <h3>
    {{parameter.implemento.descricao}}<br>
    <small class="text-light">{{parameter.maquina.descricao}}</small>
  </h3>
  <h2 ng-if="parameter.subtipo.id == 'gema'">
    {{parameter.totais_cana.total_gemas | number:0}} gemas<br>
    <small>({{parameter.totais_cana.total_viaveis | number:0}} Viáveis)</small>
  </h2>
  <h2 ng-if="parameter.subtipo.id == 'semente' && parameter.tipo_medida.id == 'peso'">
    {{parameter.densidade | number:0}} kg/ha (semente)<br>
    <small>{{parameter.media | number:2}} kg/m</small>
  </h2>
  <h2 ng-if="parameter.subtipo.id == 'semente' && parameter.tipo_medida.id != 'peso'">
    {{parameter.densidade | number:0}} sementes/ha<br>
    <small>{{parameter.media | number:2}} sementes/m</small>
  </h2>
  <h2 ng-if="parameter.subtipo.id == 'adubo'">
    {{parameter.densidade | number:1}} kg/ha (adubo)<br>
    <small>{{parameter.media | number:2}} kg/m</small>
  </h2>

  <ul class="list-unstyled">
    <li>
      Torroamento: {{parameter.torroamento.descricao}}
    </li>

    <li>
      Consistência do solo: {{parameter.consistencia.descricao}}
    </li>

    <span ng-if="parameter.subtipo.id === 'gema'">
      <li>
        Profundidade de subsolagem(cm): {{parameter.profundidade_subsolagem | number: 2}}
      </li>

      <li>
        Profundidade de sulcação(cm): {{parameter.sulcacao | number: 2}}
      </li>

      <li>
        Espaçamento Paralelismo(cm): {{parameter.espacamento_paralelismo | number: 2}}
      </li>

      <li>
        Altura Cobrição(cm): {{parameter.altura_cobricao | number: 2}}
      </li>

      <li>
        Profundidade Subamostras(cm): {{parameter.profundidade_subamostras | number: 2}}
      </li>
    </span>

    <li ng-if="parameter.profundidade">
      Profundidade: {{parameter.profundidade | number:2}} cm
    </li>

    <span ng-if="parameter.informarDistancia">
      <li>
        C.V. Médio de Distribuição: {{parameter.uniformidadeDistribuicao | number:2}} %
      </li>
      <li>
        Média Plantas Inconformes Pos. Ideal: {{parameter.plantasInconformes | number:2}} %
      </li>
    </span>

    <li>
      Linhas: {{parameter.linhas.length}}
      &nbsp;<i class="icon-info text-muted"
      aria-hidden="true"
      uib-tooltip-template="parameter.subtipo.id === 'gema' ? 'tooltip-lines-afericao-semeadura-cana.html' : 'tooltip-lines-afericao-semeadura.html'"
      tooltip-class="tooltip-lines-width"
      tooltip-placement="right"
      tooltip-append-to-body="true"></i>
    </li>
    <li>
      Comprimento: {{parameter.comprimento | number:1}}m
    </li>
    <li>
      Distância entre linhas: {{parameter.espacamento | number:2}}m
    </li>

    <li ng-if="parameter.observacoes.length > 0">
      {{parameter.observacoes}}
    </li>
    <li>
      Velocidade: {{parameter.velocidade ? parameter.velocidade + 'km/h' : 'N/A'}}
    </li>
  </ul>
</script>

<script type="text/ng-template" id="aplicacao_afericao.html">
  <p class="iw-subtitle clearfix">
    <i class="icon-culture i-subtitle" aria-hidden="true"></i>
    <span>
      <span ng-if="parameter.cultura" class="first-line">{{parameter.cultura.descricao | capitalize}}</span>
    </span>
  </p>

  <h3>
    {{parameter.maquina.descricao}}
  </h3>
  <h2>
    Total Gasto {{(parameter.total_gasto) | number:2}} mL<br>
    <small>Total Gasto por hectare {{(parameter.total_gasto / 1000) | number:2}} L/ha</small><br>
    <small>Média das Amostras {{parameter.media_amostra | number:2}} mL</small>
  </h2>

  <ul class="list-unstyled">
    <li>
      Comprimento: {{parameter.comprimento}} m
    </li>
    <li>
      Largura: {{parameter.largura}} m
    </li>
    <li>
      Espaçamento: {{parameter.espacamento}} m
    </li>
    <li>
      Número de bicos: {{parameter.largura / parameter.espacamento}}
    </li>
    <li>
      Quantidade de amostra(s): {{parameter.amostras.length}}
    </li>
    <li>
      Observações: {{parameter.observacoes}}
    </li>
  </ul>
</script>

<script type="text/ng-template" id="ponto_comentario.html">
  <p class="iw-info">{{parameter.comentario || 'Sem comentário adicionado!'}}</p>
</script>

<script type="text/ng-template" id="cultura_cultivar_edit">
  <p class="iw-subtitle clearfix">
    <i class="icon-culture i-subtitle" aria-hidden="true"></i>
    <span>
      <span class="first-line">{{parameter.atividade | capitalize}}</span>
      <span class="second-line text-italic" ng-hide="cultivares.loading || cultivares.dados">
        ({{parameter.cultivar || 'n/a'}})
        <i ng-if="canEditCultivar(parameter)" class="fa fa-pencil-square pointer" aria-hidden="true" ng-click="listCultivares()"></i>
      </span>
    </span>
    <span ng-show="cultivares.loading">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
    <span ng-hide="cultivares.loading || !cultivares.dados">
      <select class="form-control input-sm" ng-model="parameter.cultivarSelected"
              ng-options="cult as cult.descricao for cult in cultivares.dados track by cult.id">
      </select>
      <i class="fa fa-check-square text-primary pointer" aria-hidden="true" ng-click="changeCultivar()"></i>
      <i class="fa fa-minus-square text-danger pointer" aria-hidden="true" ng-click="resetCultivares()"></i>
    </span>
  </p>
</script>

<script type="text/ng-template" id="tooltip-lines-afericao-semeadura.html">
  <table class="table no-margin no-padding">
    <thead>
      <tr>
        <th ng-if="parameter.subtipo.id == 'semente' && parameter.tipo_medida.id != 'peso'">Sementes</th>
        <th ng-if="parameter.subtipo.id == 'semente' && parameter.tipo_medida.id == 'peso'" >Peso Sementes (gr)</th>
        <th ng-if="parameter.subtipo.id == 'adubo'">Peso</th>
        <th ng-if="parameter.informarDistancia">Uniformidade da Distribuição (CV) %</th>
        <th ng-if="parameter.informarDistancia">Plantas inconformes Pos. Ideal %</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="line in parameter.linhas track by $index">
        <td ng-if="parameter.subtipo.id == 'semente'">{{line.atributo | number:2}} <span ng-if=line.linhaDaMedida>linha: {{line.linhaDaMedida}}</span> </td>
        <td ng-if="parameter.subtipo.id == 'adubo'">{{line.atributo | number:2}} g <span ng-if=line.linhaDaMedida>linha: {{line.linhaDaMedida}}</span></td>
        <td ng-if="parameter.informarDistancia">{{line.uniformidadeDistribuicao | number:2}}%</td>
        <td ng-if="parameter.informarDistancia">{{line.plantasInconformes | number:2}}%</td>
      </tr>
    </tbody>
  </table>
</script>

<script type="text/ng-template" id="tooltip-lines-afericao-semeadura-cana.html">
  <table class="table no-margin no-padding">
    <thead>
      <tr>
        <th>Total Gemas</th>
        <th>Viáveis</th>
        <th>Não Viáveis</th>

      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="line in parameter.linhas track by $index">
        <td> {{line.atributo | number}} </td>
        <td> {{line.viaveis | number}} </td>
        <td> {{line.nao_viaveis | number}} </td>
      </tr>
    </tbody>
  </table>
</script>
